"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
//# sourceMappingURL=data-access-config.js.map